import { ApiResult } from '../../models/Enums'
import { axiosPost } from './Axios'
import toast from 'react-hot-toast'
import {
  removeFromInventories,
  insertToInventories,
  setInInventory,
  setOutInventory,
} from '../../store/mainSlice'
import { useAppDispatch } from '../../store'

export const registerInventory = async (
  jobId: number,
  userId: number,
  dispatch: any,
  onSuccess?: () => void
): Promise<boolean> => {
  //const dispatch = useAppDispatch()

  const payload = { id: 0, jobId, userId, memo: '' }

  const result = await axiosPost('/api/inventory/register', payload)

  if (result.apiResult !== ApiResult.SUCCESS) {
    toast.error('인벤토리 추가에 실패했습니다.')
    return false
  }

  // 인벤토리객체를 인벤토리 리스트에 추가한다.
  dispatch(insertToInventories(result.data))

  // Job의 isInInventory를 true로 바꾼다
  dispatch(setInInventory({ jobId, userId }))

  // 성공시 콜백호출
  onSuccess?.()

  toast.success('인벤토리에 추가되었습니다.')

  return true
}

export const unregisterInventory = async (
  jobId: number,
  userId: number,
  dispatch: any,
  onSuccess?: () => void
): Promise<boolean> => {
  const payload = { userId, jobId }

  const result = await axiosPost('/api/inventory/unregister', payload)

  if (result.apiResult !== ApiResult.SUCCESS) {
    toast.error('인벤토리에서 제거에 실패했습니다.')
    return false
  }

  // 인벤토리객체를 인벤토리 리스트에서 삭제한다
  dispatch(removeFromInventories({ userId, jobId }))

  // Job의 isInInventory를 false로 바꾼다
  dispatch(setOutInventory({ jobId, userId }))

  onSuccess?.()

  toast.success('인벤토리에서 제거되었습니다.')

  return true
}
